import { Button } from "@/atoms-react/button/Button.react.tsx";
import InputLabel from "@/atoms-react/input/Input.react.tsx";
import { WebAuthnRegisterApi } from "@/features/auth/api-client/webauthn-register-api-client.ts";
import { LimitCredentialInterface } from "@/features/auth/types";
import { useUser } from "@/features/user/hooks/use-user-vue";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

type NewWebauthnDeviceProps = {
  checkAuthorisation: boolean;
  onComplete: () => Promise<void>;
};
export const NewWebauthnDevice = ({
  checkAuthorisation = false,
  onComplete
}: NewWebauthnDeviceProps) => {
  const { t } = useTranslation(["pass"]);
  const { user } = useUser();
  const { getLanguage } = usei18n();

  const short = [
    user?.naturalPerson.FirstName?.slice(0, 1),
    `${user?.naturalPerson.LastName?.slice(0, 2)}.`
  ]
    .filter((a) => a && a !== ".")
    .join("")
    .slice(0, 2);

  const language = getLanguage(); // Assuming you have a similar hook for i18n
  const [deviceName, setDeviceName] = useState(
    `${language === "fr" ? `Appareil de` : `Device of`} ${short}`
  );
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    let userActiveCredentials: LimitCredentialInterface[] = [];
    try {
      userActiveCredentials = await WebAuthnRegisterApi.retrieveWebAuthnActiveCredentials();
    } catch (_) {
      console.log("no active credentials");
    }
    try {
      const hasSameDeviceName = userActiveCredentials.some(
        (userActiveCredential) => userActiveCredential["device_name"] === deviceName
      );
      if (!hasSameDeviceName) {
        const challenge = await WebAuthnRegisterApi.registerWebAuthnUser(
          deviceName,
          checkAuthorisation
        );
        if (challenge) {
          onComplete();
        }
      } else {
        toast.error(
          t("olkypass.securityPage.webauthnSection.devices.notifications.update.same_name")
        );
      }
    } catch (_) {
      toast.error(t("olkypass.securityPage.webauthnSection.devices.notifications.add.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <InputLabel
        onChange={(value) => setDeviceName(value)}
        className="mt-4 mb-3"
        label={`* ${t("olkypass.securityPage.webauthnSection.devices.table.columns.device_name")}`}
        placeholder={`${t(
          "olkypass.securityPage.webauthnSection.devices.placeholder_new_device"
        )} ${short}`}
        required
        value={deviceName}
      />
      <Button
        className="float-right mt-4"
        disabled={!deviceName}
        loading={loading}
        onClick={handleSubmit}
      >
        {t("olkypass.general.next")}
      </Button>
    </div>
  );
};
